import { getRequest, HandlerResponse, postRequest } from './api';
import { ObjToQueryString } from '../utility-functions/UtilityFns';
import { API_URL } from './Environment';

export const getOrdersAPI = async (_queryParams) => {
  const queryString = ObjToQueryString(_queryParams);
  return getRequest(`${API_URL}integration/wordPressFetchOrders${queryString}`)
    .then((resp) => HandlerResponse(resp));
};

export const createOrderAPI = async(_queryParams,payload) => {
  const queryString = ObjToQueryString(_queryParams);
  return postRequest(`${API_URL}integration/orders${queryString}`,payload)
    .then((resp) => resp);
}
